// Shared formatters (Curro redesign) — en-ZA, true minus sign for credits.

export const fmtR = (v) => (v < 0 ? "−R" : "R") + Math.round(Math.abs(v)).toLocaleString("en-ZA");
export const fmtRm = (v) => `${v < 0 ? "−" : ""}R${(Math.abs(v) / 1e6).toFixed(1)}m`;
export const fmtN = (v) => Math.round(v).toLocaleString("en-ZA");
export const fmtPct = (v) => `${v.toFixed(1)}%`;

// Westfert agri chart palette (parts-of-a-whole + categorical bars).
export const PALETTE = ["#71B52B", "#3F7D17", "#138A6E", "#E0A21A", "#C77D4A", "#9ACB3C", "#5C7A24", "#8A5A2B", "#9DA790"];
